import React from 'react';
import ProjectsList from "../../common/components/Projects/ProjectsList";

const Projects = ({ projects}) => {
    return (<>
            {Array.isArray(projects) && <>
                <div className="py-6">
                    <div className="container text-center">
                        <div className="mb-5 center mw-600px">
                            <h3 className="font-bold">Support New Zealand Native Forest Projects That Help Fight Climate Change</h3>
                            <h5>CarbonClick carefully selects and supports the establishment of new forests around New Zealand.</h5>
                        </div>
                        <div className="text-left mobile-text-center">
                            <ProjectsList title={null} projects={projects} />
                        </div>
                    </div>
                </div>
            </>}
            </>
    );
};

export default Projects;